export default "__VITE_PUBLIC_ASSET__61313ac9__"